import ShopMenu from '../ShopMenu';
import { LockableFooterButton } from './LockableFooterButton';

export class ShopMenuButton extends LockableFooterButton {
  private shopMenu: ShopMenu | undefined;

  constructor() {
    super({ type: 'shop' });
  }

  public setActive(isActive: boolean) {
    super.setActive(isActive);
    if (isActive) {
      this.shopMenu = new ShopMenu();
      this.shopMenu?.once('Close', () => this.onClick());
      this.shopMenu?.fadeIn(this.getSuperview()!);
    } else {
      this.shopMenu?.fadeOut();
    }
  }
}
